export default {
	connectezVous: 'Connectez-vous',
	connectezVousAssure: 'Connectez-vous en tant que salarié(e)',
	connectezVousEmployeur: 'Connectez-vous en tant qu\'employeur particulier',
	withQrp: 'Connectez-vous avec vos identifiants QRP',
	firstConnexion: 'Première connexion ? ',
	forgottenPwd: 'Mot de passe oublié ?',
	seConnecter: 'Se connecter',
	email: 'Adresse email',
	password: 'Mot de passe',
	error404: 'Email ou mot de passe erroné',
	errorCode: 'Code incorrect',
	withMce: 'Connexion à mon espace employeur',
	withMceSubtitle: 'Utilisez vos identifiants net-entreprises.fr pour vous connecter',
	connexionNetE: 'Pour les employeurs, l’accès à QRP se fait maintenant sur "mon compte entreprise" depuis '
};
